// extracted by mini-css-extract-plugin
module.exports =  {"activityFlexContainer":"_activityFlexContainer--2LF4_"};